import { render, staticRenderFns } from "./RolesManagementPermissionDetail.vue?vue&type=template&id=3ea910b5&scoped=true"
import script from "./RolesManagementPermissionDetail.vue?vue&type=script&lang=js"
export * from "./RolesManagementPermissionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea910b5",
  null
  
)

export default component.exports